import { FamilyDTO } from '../family/family';
import { PointSummaryDTO } from '../point-summary/point-summary-dto';

export interface FamilyPointSummary {
  family: FamilyDTO;
  pointSummary: PointSummaryDTO;
}

/**
 * Summary of user points
 */
export class BusinessSummaryDTO {
  /**
   * @constructor
   */
  constructor(public pointsByFamily: FamilyPointSummary[] = []) {}
}
